export const transformedMyworkflowList =(dataArray)=>{
    return dataArray.map(data => ({
        ...data,
        total_runs: {
            success: (data.status_skipped || 0) + (data.status_completed || 0),
            pending: (data.status_ready || 0) + (data.status_inprogress || 0) + 
                     (data.status_paused || 0) + (data.status_waiting || 0),
            warning: data.status_warning || 0,
            failed: (data.status_failed || 0) + (data.status_terminated || 0)
        }
    }));
}


export function formatDate(date) {
    return new Date(date).toISOString().split('T')[0]; // Extracts YYYY-MM-DD
}

export const transformeddashboardtiles = (data) => {
  const keys = [
    { label: "Success", value: "success_count" },
    { label: "In Progress", value: "pending_count" },
    { label: "Warning", value: "warning_count" },
    { label: "Error", value: "failed_count" }
  ];

  // Calculate grand total of relevant keys
  const grandTotal = keys.reduce((sum, key) => {
    return sum + (data[key.value] || 0);
  }, 0);

  const dashboardTiles = keys.map((item) => {
    const count = data[item.value] || 0;
    const percentage =
      grandTotal > 0 ? ((count / grandTotal) * 100).toFixed(2) : "0.00";

    return {
      status: item.label,
      count,
      percentage: parseFloat(percentage) // Optional: keep as number instead of string
    };
  });

  return { dashboardTiles };
};
